import * as React from 'react';

import { trackMortgageOffersTabClick } from '../MortgageSection/tracking';

import { SeoMortgageLink } from './SeoMortgageLink';
import { useMortgageCalculatorContext } from '../../contexts/MortgageCalculatorContext';

export const SeoMortgageLinkContainer: React.FC = () => {
  const { mortgageSeoPageUrl } = useMortgageCalculatorContext();

  const onClick = React.useCallback(() => {
    trackMortgageOffersTabClick('seoUrl');
  }, []);

  if (!mortgageSeoPageUrl) {
    return null;
  }

  return (
    <SeoMortgageLink
      testId="seo_mortgage_link"
      title="Ипотечные предложения и аккредитованные банки"
      url={mortgageSeoPageUrl}
      onClick={onClick}
    />
  );
};
